// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_fw-0";
export var fileCarousel = "_fw-2";
export var removeFileButton = "_fw-1";